import { querySelector } from '../functions/querySelectors';
import alert from '../modules/alert';
import setCookie from '../functions/setCookie';

const CONTENT_CLASS = 'js-exit-modal-alert-content';
const CONTENT_ACTIVE_CLASS = 'c-exit-modal--active';
const COOKIE_SHOWS = 'gfalertds';

let openModal = function() {
  let element = querySelector(`.${CONTENT_CLASS}`);

  if (element) {
    element.classList.add(CONTENT_ACTIVE_CLASS);

    alert.open({
      nodeElement: element
    });
  }
};

let exitF = function(e) {
  e = e || window.event;
  var from = e.relatedTarget || e.toElement;

  if ((!from || from.nodeName === 'HTML') && e.clientY < 0) {
    openModal();
    setCookie(COOKIE_SHOWS, 1, 365);

    document.removeEventListener('mouseout', exitF, false);
  }
};

export function exitModal() {
  let element = querySelector(`.${CONTENT_CLASS}`);

  if (element) {
    document.addEventListener('mouseout', exitF, false);
  }
};
